var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupInfoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Report_icon",
    "data-name": "Report icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3539",
    "data-name": "Group 3539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M6.177.75H2.1A1.286,1.286,0,0,0,.75,1.953V14.045A1.285,1.285,0,0,0,2.1,15.25H13.9a1.284,1.284,0,0,0,1.353-1.2V1.966A1.283,1.283,0,0,0,13.9.761H6.177Z",
    fill: "none",
    stroke: "#0e0e0e",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x2: 8.319,
    transform: "translate(3.688 8)",
    fill: "none",
    stroke: "#0e0e0e",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    x2: 4.342,
    transform: "translate(3.906 4.696)",
    fill: "none",
    stroke: "#0e0e0e",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_963",
    "data-name": "Rectangle 963",
    width: 16,
    height: 16,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    x2: 8.345,
    transform: "translate(3.686 11.271)",
    fill: "none",
    stroke: "#0e0e0e",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupInfoIcon);
export default __webpack_public_path__ + "static/media/group-info-icon.bc1fcc9ab10e5ebed5929da2574ee9b7.svg";
export { ForwardRef as ReactComponent };